import { CardNumberElement } from '@stripe/react-stripe-js';
import { StripeCardNumberElementChangeEvent, StripeCardNumberElementOptions } from '@stripe/stripe-js';
import React, { FC, memo, useState } from 'react';
import { CARD_BRAND_IMAGES, CARD_NUMBER_PLACEHOLDER, UNKNOWN, CARD_BRAND } from './constants';
import classnames from 'classnames';
import s from './index.module.scss';
import ErrorMessage from '../errorMessage';
import { getCardFieldOptions } from '../../constants';
import locales from '../../../../../../../../../../content.json';

type Props = {
  onChange?: (event: StripeCardNumberElementChangeEvent) => void;
  className?: string;
  options?: StripeCardNumberElementOptions;
};

const CardNumber: FC<Props> = props => {
  const { onChange, options = getCardFieldOptions(CARD_NUMBER_PLACEHOLDER), className } = props;

  const [cardBrand, setCardBrand] = useState<CARD_BRAND | typeof UNKNOWN>(UNKNOWN);
  const [error, setError] = useState<string | undefined>();
  const [empty, setEmpty] = useState<boolean | undefined>(false);

  const [isFieldEmpty, setIsFieldEmpty] = useState(true);

  const handleChange = (event: StripeCardNumberElementChangeEvent) => {
    setCardBrand(event.brand as CARD_BRAND);
    setError(event?.error?.message);
    setIsFieldEmpty(event.empty);
    onChange && onChange(event);
  };
  
  const handleFocus = () => {
    setEmpty(true);
  };
  
  const handleBlur = () => {
    setEmpty(!isFieldEmpty); 
  };
  return (
    <>
      <div className={classnames(className, s.cardNumber, { [s.empty]: empty })}>
        <CardNumberElement 
          onChange={handleChange} 
          onFocus={handleFocus}
          onBlur={handleBlur}
          options={options}
        />
        {empty && (
          <span className={s.cardNumber_title}>{locales[window.userLang].payment_text_105}</span>
        )}
        {cardBrand !== UNKNOWN && (
          <img
            data-test="card-brand"
            className={s.cardNumber__brandImage}
            src={CARD_BRAND_IMAGES[cardBrand]}
            alt={cardBrand}
          />
        )}
      </div>
      {/* {error && <ErrorMessage error={error} />} */}
       <ErrorMessage error={error} />
    </>
  );
};

export default memo(CardNumber);
